export const state = {

    itemCCCDStore: null,
    imgCCCDStore: null,

    itemPassportStore: null,
    imgPassportStore: null,

    itemVisaStore: null,
    imgVisaStore: null,

    itemFaceIdStore: null,
    imgFaceIdStore: null,
}

export const mutations = {

    SET_ITEM_CCCD(state, value) {
        state.itemCCCDStore = value;
    },
    SET_ITEM_FACE_ID(state, value) {
        state.itemFaceIdStore = value;
    },
    SET_ITEM_PASSPORT(state, value) {
        state.itemPassportStore = value;
    },
    SET_ITEM_VISA(state, value) {
        state.itemVisaStore = value;
    },

    SET_IMG_CCCD(state, value) {
        state.imgCCCDStore = value;
    },
    SET_IMG_FACE_ID(state, value) {
        state.imgFaceIdStore = value;
    },
    SET_IMG_PASSPORT(state, value) {
        state.imgPassportStore = value;
    },
    SET_IMG_VISA(state, value) {
        state.imgVisaStore = value;
    }
}

export const actions = {
    async setItemCCCD({ commit }, value) {
        commit("SET_ITEM_CCCD", value)
    },
    async setItemFaceId({ commit }, value) {
        commit("SET_ITEM_FACE_ID", value)
    },
    async setItemPassport({ commit }, value) {
        commit("SET_ITEM_PASSPORT", value)
    },
    async setItemVisa({ commit }, value) {
        commit("SET_ITEM_VISA", value)
    },
    async setImgCCCD({ commit }, value) {
        commit("SET_IMG_CCCD", value)
    },
    async setImgFaceId({ commit }, value) {
        commit("SET_IMG_FACE_ID", value)
    },
    async setImgPassport({ commit }, value) {
        commit("SET_IMG_PASSPORT", value)
    },
    async setImgVisa({ commit }, value) {
        commit("SET_IMG_VISA", value)
    },

};


// this.$store.dispatch("verificationInfoStore/setItemCCCD", result);

export const getters = {
    async getItemCCCD(state) {
        return state.itemCCCDStore;
    },
    async getItemFaceId(state) {
        return state.itemFaceIdStore;
    },
    async getItemPassport(state) {
        return state.itemPassportStore;
    },
    async getItemVisa(state) {
        return state.itemVisaStore;
    },
    async getImgCCCD(state) {
        return state.imgCCCDStore;
    },
    async getImgFaceId(state) {
        return state.imgFaceIdStore;
    },
    async getImgPassport(state) {
        return state.imgPassportStore;
    },
    async getImgVisa(state) {
        return state.imgVisaStore;
    },
};


